/**
 * FramingBanner — a prominent, dismissible banner that states the split between the two
 * tools so everyone is oriented:
 *
 *   Quest            = your goals & schedule.
 *   AI Command Center = actually getting things done, with live dev-server context.
 *
 * Dismissal is persisted in localStorage so it shows once and stays gone until cleared.
 * Rendered at the app root (under the navbar) so it greets the user on first visit.
 */
import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const DISMISS_KEY = 'cockpit_framing_dismissed';

const FramingBanner: React.FC = () => {
  const { theme } = useTheme();
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === 'true';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, 'true');
    } catch {
      /* ignore */
    }
  };

  return (
    <div
      style={{
        background: `linear-gradient(90deg, ${theme.primary}14, #8b5cf614)`,
        borderBottom: `1px solid ${theme.border}`,
        padding: '12px 16px',
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          flexWrap: 'wrap',
        }}
      >
        <span style={{ fontSize: 22, flex: '0 0 auto' }}>🧭</span>
        <div style={{ flex: 1, minWidth: 220, color: theme.text, fontSize: 14, lineHeight: 1.5 }}>
          <strong style={{ color: theme.primary }}>Quest</strong> = your goals &amp; schedule.{' '}
          <strong style={{ color: '#8b5cf6' }}>This AI Command Center</strong> = actually getting
          things done, with live dev-server context.
        </div>
        <button
          type="button"
          onClick={dismiss}
          style={{
            flex: '0 0 auto',
            padding: '6px 14px',
            borderRadius: 6,
            border: `1px solid ${theme.border}`,
            backgroundColor: theme.surface,
            color: theme.text,
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default FramingBanner;
